<body>
  <ng-container
    *ngIf="
      (this.userService.loginStatus$.asObservable() | async) != 1;
      else Dashboard
    "
  >
    <!-- Only router-outlet without sidenav when loginDisplay is true -->
    <router-outlet></router-outlet>
  </ng-container>

  <ng-template #Dashboard>
    <!-- Sidenav and router-outlet when loginDisplay is false -->
    <app-sidebar>
      <router-outlet></router-outlet>
    </app-sidebar>
  </ng-template>
</body>
